var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.808,
    height: 13.75,
    viewBox: "0 0 14.808 13.75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-star",
    "data-name": "Icon ionic-ios-star",
    d: "M16.5,8.135H11.634L10.157,3.725a.535.535,0,0,0-1,0L7.674,8.135h-4.9a.53.53,0,0,0-.529.529.389.389,0,0,0,.01.089.508.508,0,0,0,.221.374l4,2.816L4.944,16.4A.53.53,0,0,0,5.126,17a.511.511,0,0,0,.3.129.648.648,0,0,0,.331-.119l3.9-2.78,3.9,2.78a.619.619,0,0,0,.331.119A.475.475,0,0,0,14.179,17a.524.524,0,0,0,.182-.595l-1.534-4.459L16.79,9.1l.1-.083a.505.505,0,0,0-.39-.883Z",
    transform: "translate(-2.25 -3.375)",
    fill: "#51cb20"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.b1d287a40889188ff11b9cbd02a67706.svg";
export { ForwardRef as ReactComponent };